import { Box, Flex, Text } from '@chakra-ui/react';
import {
  GoogleSettingsIcon,
  GoogleArchiveIcon,
  GoogleRemoveIcon,
} from '../../../../../theme/icons/googlePreviewIcons';

interface GooglePassFooterProps {
  contrastColor: string;
  backgroundColor: string;
  lightenedBg: string;
}

export const GooglePassFooter = ({
  contrastColor,
  backgroundColor,
  lightenedBg,
}: GooglePassFooterProps) => (
  <>
    <Box px="15px" pt="16px">
      <Flex
        bg={lightenedBg}
        borderRadius="10px"
        px="14px"
        py="14px"
        alignItems="center"
        gap="12px"
      >
        <GoogleSettingsIcon w="13px" h="13px" color={contrastColor} />
        <Text
          fontSize="13px"
          fontWeight="600"
          textStyle="headingFamilyRegularGooglePay"
          color={contrastColor}
        >
          Settings
        </Text>
      </Flex>
    </Box>

    <Box px="15px" pt="22px">
      <Box bg={lightenedBg} borderRadius="10px" overflow="hidden">
        <Flex px="14px" py="12px" alignItems="center" gap="12px">
          <GoogleArchiveIcon w="17px" h="17px" color={contrastColor} />
          <Text
            fontSize="13px"
            fontWeight="600"
            textStyle="headingFamilyRegularGooglePay"
            color={contrastColor}
          >
            Archive
          </Text>
        </Flex>
        <Flex
          px="14px"
          py="12px"
          alignItems="center"
          gap="12px"
          borderTop={`2px solid ${backgroundColor}`}
        >
          <GoogleRemoveIcon w="17px" h="16px" color={contrastColor} />
          <Text
            fontSize="13px"
            fontWeight="600"
            textStyle="headingFamilyRegularGooglePay"
            color={contrastColor}
          >
            Remove
          </Text>
        </Flex>
      </Box>
    </Box>

    <Box px="15px" pb="55px" pt="28px">
      <Text
        fontSize="9px"
        textStyle="headingFamilyRegularGooglePay"
        color={contrastColor}
        opacity={0.75}
      >
        The pass provider or merchant is responsible for the info on this pass
        and may send you notifications. Contact them with any questions.
      </Text>
    </Box>
  </>
);
